import React from 'react';
import { EmailConfirmationError } from '../types';
import EmailConfirmationInvalidTokenErrorPage from './EmailConfirmationInvalidTokenErrorPage';
import EmailConfirmationFormPage from './EmailConfirmationFormPage';
import { useAppSelector } from '../stores/redux.store';
import { usePageStateLoader, fetchPageState } from '../utilities/hooks/useGlobalPageState';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { checkFeatureGateOnceInitialized } from '../utilities/feature-flags/feature-gate';

export async function changeEmailLoader({ request }: { request: Request }) {
  if (!(await checkFeatureGateOnceInitialized(AidFrontendFeatureGate.USE_STATE_DATA_LOADERS))) {
    return null;
  }

  return await fetchPageState('/rest/verify-email/change-email/state', request);
}

export const EmailConfirmationPage = () => {
  usePageStateLoader();

  const error = useAppSelector(state => state.changeEmail.error);
  if (error === EmailConfirmationError.InvalidToken) {
    return <EmailConfirmationInvalidTokenErrorPage />;
  } else {
    return <EmailConfirmationFormPage />;
  }
};

export default EmailConfirmationPage;
